export const siteChromeNavigationStoreKey = "Asos.SiteChrome.Navigation";
export const expirationInMs = 5 * 60 * 1000;
export const ALWAYS_INCLUDED_BENEFIT_TYPES = ["EarlyAccessToNewIn"];
